import ReactEcharts from "echarts-for-react";
import { hexColor } from "../../../../../enums/colors";
import { TbCircleFilled } from "react-icons/tb";
import { t } from "i18next";
import { SummaryPersonUsageRow, SummaryUsageRow } from "../../../../../stores/TabsStore";
import { useAppStore } from "../../../../../stores/RootStore";
import { Equipment } from "../../../../../types/types";

export const EquipmentLoaded = ({equipment, data}: {equipment: Equipment, data: SummaryUsageRow}) => {
  const {theme} = useAppStore()
  let colorPalette = [hexColor.worked, hexColor.stopped, hexColor.turned_off]

  const getOptions = () => ({
    series: [
      {
        name: `${equipment.attributes.name}`,
        type: "pie",
        radius: ['55%', '90%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 6,
          borderColor: theme === 'light' ? hexColor.background : hexColor.foreground,
          borderWidth: 2
        },
        label: {
          show: false,
          position: 'center'
        },
        labelLine: {
          show: false
        },
        color: colorPalette,
        data: [
          { name: "work", value: data.availability.worked.seconds, color: hexColor.worked },
          { name: "idle", value: data.availability.stopped.seconds, color: hexColor.stopped },
          { name: "turned_off", value: data.availability.off.seconds, color: hexColor.turned_off},
        ],
      },
    ]
  });


  return (
    <div className="flex flex-col w-full text-sm my-4 px-2">
      <div className="grid grid-cols-1 lg:grid-cols-3 my-4 gap-4">
        <div className="flex w-full justify-center lg:px-6">
          <ReactEcharts option={getOptions()} style={{ height: 120, width: 120 }} opts={{renderer: 'svg'}} />
        </div>
        <div className="flex flex-col w-full gap-3 lg:border-l border-border lg:px-6">
            <div className="grid grid-cols-2">
              <div className="flex font-semibold">{t('availability')}</div>
              <div className="flex font-semibold">{data.availability.total.time}</div>
            </div>
            <div className="grid grid-cols-2">
              <div className="flex flex-col">
                <div className="flex items-center space-x-2">
                  <TbCircleFilled className="w-3 h-3" style={{color: hexColor.worked}}/>
                  <span className="text-secondary-foreground">{t('worked')}:</span>
                </div>
                <span className="font-medium text-base">{data.availability.worked.time} ({(data.availability.worked.percent * 100).toFixed(2)} %)</span>
              </div>
              <div className="flex flex-col">
                <div className="flex items-center space-x-2">
                  <TbCircleFilled className="w-3 h-3" style={{color: hexColor.stopped}}/>
                  <span className="text-secondary-foreground">{t('stopped')}:</span>
                </div>
                <span className="font-medium text-base">{data.availability.stopped.time} ({(data.availability.stopped.percent * 100).toFixed(2)} %)</span>
              </div>
            </div>
            <div className="grid grid-cols-2">
              <div className="flex flex-col">
                <div className="flex items-center space-x-2">
                  <span className="text-secondary-foreground">{t('maintenance')}:</span>
                </div>
                <span className="font-medium text-base">{data.maintenance.total.time} ({(data.maintenance.total.percent * 100).toFixed(2)} %)</span>
              </div>
              <div className="flex flex-col">
                <div className="flex items-center space-x-2">
                  <span className="text-secondary-foreground">{t('turned_off')}:</span>
                </div>
                <span className="font-medium text-base">{data.availability.off.time} ({(data.availability.off.percent * 100).toFixed(2)} %)</span>
              </div>
            </div>
        </div>
        <div className="flex flex-col w-full gap-3 lg:border-l border-border lg:px-6">
          <div className="grid grid-cols-2">
            <div className="flex font-semibold">{t('unavailability')}</div>
            <div className="flex font-semibold">{data.unavailability.total.time}</div>
          </div>
          <div className="grid grid-cols-2">
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.turned_off}}/>
                <span className="text-secondary-foreground">{t('broken')}:</span>
              </div>
              <span className="font-medium text-base">{data.broken.total.time} ({data.broken.total.percent.toFixed(2)} %)</span>
            </div>
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.turned_off}}/>
                <span className="text-secondary-foreground">{t('repair')}:</span>
              </div>
              <span className="font-medium text-base">{data.repair.total.time} ({data.repair.total.percent.toFixed(2)} %)</span>
            </div>
          </div>
          <div className="grid grid-cols-2">
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.turned_off}}/>
                <span className="text-secondary-foreground">{t('service')}:</span>
              </div>
              <span className="font-medium text-base">{data.service.total.time} ({data.service.total.percent.toFixed(2)} %)</span>
            </div>
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.turned_off}}/>
                <span className="text-secondary-foreground">{t('turned_off')}:</span>
              </div>
              <span className="font-medium text-base">{data.unavailability.off.time} ({data.unavailability.off.percent.toFixed(2)} %)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}